import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const ngaoApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'ngaoApi',
  tagTypes: ['NgaoOtp'],
  endpoints: () => ({})
})

export default ngaoApi
